import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore"; // Import Firestore functions
import { getAuth,onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth
import { getStorage } from "firebase/storage";
import { toast } from "react-toastify";
import NotificationStyle from "./NotificationStyle";
import defaultimage from '../user.png'


const firebaseConfig = {
    apiKey: "AIzaSyBoH1IwGVqsB2KHx_CA6xrfclCHvQIVu58",
  authDomain: "wmchat-57f66.firebaseapp.com",
  projectId: "wmchat-57f66",
  storageBucket: "wmchat-57f66.firebasestorage.app",
  messagingSenderId: "312754841279",
  appId: "1:312754841279:web:503959a1783b4a935e080a",
  measurementId: "G-3WSX1CW5K8"
  };

// const firebaseConfig = {
//   apiKey: "AIzaSyBoH1IwGVqsB2KHx_CA6xrfclCHvQIVu58",
//   authDomain: "wmchat-57f66.firebaseapp.com",
//   projectId: "wmchat-57f66",
//   storageBucket: "wmchat-57f66.firebasestorage.app",
//   messagingSenderId: "312754841279",
//   appId: "1:312754841279:web:3fd0cf1bd5928f2a5e080a",
//   measurementId: "G-3WSX1CW5K8"
// };
    
  
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const db = getFirestore(app); // Initialize Firestore
  const auth = getAuth(app); // Initialize Firebase Auth
  const messaging = getMessaging(app);
  const storage = getStorage(app);
  
  // Function to play notification sound in foreground
  const playNotificationSound = () => {
    try {
      // Check if we can play audio
      if ('AudioContext' in window || 'webkitAudioContext' in window) {
        const audio = new Audio('/microsoft_teams_call.mp3');
        audio.volume = 0.5; // Set volume to 50%
        audio.play().catch(error => {
          console.log('Could not play notification sound:', error);
          // Fallback: try to play a simple beep
          playFallbackBeep();
        });
      } else {
        playFallbackBeep();
      }
    } catch (error) {
      console.log('Audio not supported:', error);
      playFallbackBeep();
    }
  };

  // Fallback beep sound using Web Audio API
  const playFallbackBeep = () => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (error) {
      console.log('Fallback beep failed:', error);
    }
  };

// Function to request notification permissions
const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    console.log("This browser does not support notifications");
    return false;
  }

  if (Notification.permission === "granted") {
    console.log("Notification permission already granted");
    return true;
  }

  if (Notification.permission === "denied") {
    console.log("Notification permission denied by user");
    toast.error("Please enable notifications in your browser settings to receive message alerts", { autoClose: 5000 });
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Notification permission granted");
      toast.success("Notifications enabled! You'll now receive alerts for new messages", { autoClose: 3000 });
      return true;
    } else {
      console.log("Notification permission denied");
      toast.warning("Notification permission denied. You won't receive alerts for new messages", { autoClose: 3000 });
      return false;
    }
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return false;
  }
};

// Function to check notification permission status
const getNotificationPermissionStatus = () => {
  if (!("Notification" in window)) {
    return "unsupported";
  }
  return Notification.permission;
};

// Enhanced notification handling with sound support
  const showNotificationWithSound = (data, isBackground = false) => {
    const senderName = data.title || (data.sender_id ? `User ${data.sender_id}` : "Unknown");
    const message = data.body || "";
    let profilePic = data.userprofile || "";
    const defaultProfile = defaultimage;
    
    if (!profilePic || profilePic === "null" || profilePic === "undefined") {
      profilePic = defaultProfile;
    }

    // Use sender_id as toastId for uniqueness per sender
    const toastId = data.sender_id ? `sender-toast-${data.sender_id}` : undefined;

    const toastContent = (
      <div style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
        <img 
          src={profilePic} 
          alt="profile" 
          style={{ 
            width: 40, 
            height: 40, 
            marginRight: 12, 
            borderRadius: '50%', 
            objectFit: 'cover', 
            background: '#eee',
            border: '2px solid #fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }} 
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ 
            fontWeight: 'bold', 
            fontSize: 14, 
            color: '#333',
            marginBottom: '4px',
            lineHeight: '1.2'
          }}>
            {senderName}
          </div>
          <div style={{
            fontSize: 13,
            color: '#666',
            lineHeight: '1.3',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 200,
            whiteSpace: 'normal',
          }}>
            {message && message.length > 100 ? message.slice(0, 100) + '...' : message}
          </div>
        </div>
      </div>
    );

    // Check if tab is visible/active
    const isTabVisible = !document.hidden;
    
    // Play notification sound if tab is not visible or if explicitly requested
    if (!isTabVisible || !isBackground) {
      playNotificationSound();
    }

    // Show toast notification only if tab is visible
    if (isTabVisible) {
      if (toast.isActive(toastId)) {
        toast.update(toastId, {
          render: toastContent,
          autoClose: 3000,
          position: 'top-right',
          style: {
            background: '#fff',
            color: '#333',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            border: '1px solid #e0e0e0'
          }
        });
      } else {
        toast(toastContent, {
          autoClose: 3000,
          position: 'top-right',
          toastId: toastId,
          style: {
            background: '#fff',
            color: '#333',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            border: '1px solid #e0e0e0'
          }
        });
      }
    }

    // If tab is not visible, also show a browser notification
    if (!isTabVisible) {
      showBrowserNotification(data);
    }
  };

  // Function to show browser notification when tab is not visible
  const showBrowserNotification = (data) => {
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return;
    }

    if (Notification.permission === "granted") {
      const senderName = data.title || (data.sender_id ? `User ${data.sender_id}` : "Unknown");
      const message = data.body || "";
      
      const notification = new Notification(senderName, {
        body: message,
        icon: data.userprofile || '/default-profile.png',
        badge: '/chat-icon.png',
        tag: 'chat-notification',
        requireInteraction: false,
        silent: false, // This will play the system notification sound
        data: {
          url: window.location.href,
          senderId: data.sender_id
        }
      });

      // Handle notification click
      notification.onclick = function() {
        window.focus();
        this.close();
      };

      // Auto close after 5 seconds
      setTimeout(() => {
        notification.close();
      }, 5000);
    }
  };

  // Tab visibility change handler
  const handleTabVisibilityChange = () => {
    if (document.hidden) {
      console.log('Tab is now hidden - notifications will use browser notifications');
    } else {
      console.log('Tab is now visible - notifications will use toast');
    }
  };

  // Add tab visibility listener
  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', handleTabVisibilityChange);
  }

  // Test notification sound function
  const testNotificationSound = () => {
    playNotificationSound();
    toast.success('Testing notification sound...', { autoClose: 2000 });
  };

  // Test background notification function
  const testBackgroundNotification = () => {
    const testData = {
      title: 'Test User',
      body: 'This is a test message to simulate background notification',
      sender_id: 'test-123',
      userprofile: '/default-profile.png'
    };
    
    // Simulate background notification
    showNotificationWithSound(testData, true);
    
    // Also test browser notification
    showBrowserNotification(testData);
    
    toast.success('Testing background notification...', { autoClose: 2000 });
  };

  // Test tab visibility function
  const testTabVisibility = () => {
    const isHidden = document.hidden;
    toast.info(`Tab is currently ${isHidden ? 'hidden' : 'visible'}`, { autoClose: 2000 });
    console.log('Tab hidden:', isHidden);
    console.log('Tab visibility state:', document.visibilityState);
  };

  // Make test functions available globally for testing
if (typeof window !== 'undefined') {
  window.testNotificationSound = testNotificationSound;
  window.testBackgroundNotification = testBackgroundNotification;
  window.testTabVisibility = testTabVisibility;
  window.playNotificationSound = playNotificationSound;
  window.requestNotificationPermission = requestNotificationPermission;
  window.getNotificationPermissionStatus = getNotificationPermissionStatus;
}

  // Function to fetch user details
  // const fetchUserDetails = async (userId) => {
  //   const userDoc = doc(db, "users", userId); // Assuming user data is stored in 'users' collection
  //   const userSnapshot = await getDoc(userDoc);
  //   if (userSnapshot.exists()) {
  //     console.log("User data:------>", userSnapshot.data());
  //     return userSnapshot.data(); // Return user data
  //   } else {
  //     console.log("No such user!");
  //     return null;
  //   }
  // };
  
  // fetchUserDetails('190')



  if ("serviceWorker" in navigator) {
    console.log("Service Worker is supported, attempting registration...");
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Service Worker registered successfully:", registration);
  
        // Wait a bit before trying to get token
        setTimeout(() => {
          getToken(messaging, {vapidKey:"BHFUIBltQomO9PhS8syuAc-KthjWDObSs4x0z8HSHiKhDbEmAsXaVsnzbwqTOJY8b6Lbtv_ttTJLvZhuEHygmOA",}).then((currentToken) => {
              if (currentToken) {
                console.log("FCM token generated successfully:", currentToken.substring(0, 50) + "...");
                localStorage.setItem("chat_device_token", currentToken);
                
              } else {
                console.log(
                  "No registration token available. Request permission to generate one."
                );
              }
            })
            .catch((err) => {
              console.error("Error getting FCM token:", err);
              console.error("Error details:", {
                code: err.code,
                message: err.message,
                stack: err.stack
              });
            });
        }, 3000); // Wait 3 seconds for service worker to fully initialize
 
        onMessage(messaging, (payload) => {
          console.log("[firebaseInitial.jsx] Foreground message received", payload);
          
          const data = payload.data || {};
          const currentUser = JSON.parse(localStorage.getItem("authUser"));
          const currentUserId = currentUser?.id;
          const senderId = data.sender_id;
          
          // Don't show notification if sender is receiving their own message
          if (senderId && String(senderId) === String(currentUserId)) {
            console.log("Suppressing notification - sender receiving own message");
            return;
          }
          
          // Don't show notification if user is viewing this chat
          const currentChatUserId = localStorage.getItem('current_user');
          if (currentChatUserId && String(currentChatUserId) === String(senderId)) {
            console.log("Suppressing notification - user viewing this chat");
            return;
          }
          
          // Enhanced notification handling with sound support
          showNotificationWithSound(data);
        });
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
  
      });
  }

// Function to refresh FCM token
export const refreshFCMToken = async () => {
  try {
    console.log("Refreshing FCM token...");
    
    // Force service worker registration
    if ('serviceWorker' in navigator) {
      try {
        // Unregister existing service worker first
        const existingRegistration = await navigator.serviceWorker.getRegistration();
        if (existingRegistration) {
          await existingRegistration.unregister();
          console.log("Unregistered existing service worker");
        }
        
        // Register new service worker
        console.log("Registering new service worker...");
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log("Service worker registered:", registration);
        
        // Wait for service worker to be ready
        await new Promise(resolve => setTimeout(resolve, 3000));
      } catch (swError) {
        console.error("Service worker registration error:", swError);
      }
    }
    
    // Request permission
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      // Try multiple times to get token
      let token = null;
      let attempts = 0;
      const maxAttempts = 3;
      
      while (!token && attempts < maxAttempts) {
        attempts++;
        console.log(`Attempt ${attempts} to get FCM token...`);
        
        try {
          token = await getToken(messaging, {
            vapidKey: "BHFUIBltQomO9PhS8syuAc-KthjWDObSs4x0z8HSHiKhDbEmAsXaVsnzbwqTOJY8b6Lbtv_ttTJLvZhuEHygmOA",
            serviceWorkerRegistration: await navigator.serviceWorker.getRegistration()
          });
          
          if (token) {
            console.log("FCM token generated successfully:", token.substring(0, 50) + "...");
            break;
          }
        } catch (tokenError) {
          console.error(`Token generation attempt ${attempts} failed:`, tokenError);
          if (attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, 2000));
          }
        }
      }
      
      if (token) {
        localStorage.setItem("chat_device_token", token);
        localStorage.setItem("device_token", token);
        
        // Update Firestore if user is logged in
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        if (authUser?.id) {
          try {
            const userRef = doc(db, "users", String(authUser.id));
            await updateDoc(userRef, { deviceToken: token });
            console.log("FCM token updated in Firestore");
          } catch (firestoreError) {
            console.error("Firestore update error:", firestoreError);
          }
        }
        
        return token;
      } else {
        console.error("Failed to generate FCM token after multiple attempts");
        return null;
      }
    } else {
      console.error("Notification permission denied");
      return null;
    }
  } catch (error) {
    console.error("Error refreshing FCM token:", error);
    return null;
  }
};

// Auto-refresh FCM token every 6 hours to prevent expiration
const startAutoRefresh = () => {
  setInterval(async () => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      if (authUser?.id) {
        console.log("Auto-refreshing FCM token...");
        const newToken = await refreshFCMToken();
        if (newToken) {
          console.log("FCM token auto-refreshed successfully");
        }
      }
    } catch (error) {
      console.error("Auto-refresh FCM token error:", error);
    }
  }, 6 * 60 * 60 * 1000); // 6 hours
};

// Start auto-refresh when the app loads
startAutoRefresh();

export { 
  app, 
  getToken, 
  onMessage, 
  db, 
  messaging, 
  storage,
  playNotificationSound,
  showNotificationWithSound,
  requestNotificationPermission,
  getNotificationPermissionStatus,
  testNotificationSound,
  testBackgroundNotification
};
  